import axios from "axios";

export default {
  namespaced: true,
  state: {
    dashboard: [],
    targets: [],
  },
  getters: {
    dashboard: (state) => state.dashboard,
    targets: (state) => state.targets,
  },
  mutations: {
    SET_DASHBOARD(state, data) {
      state.dashboard = data;
    },
    SET_TARGETS(state, data) {
      state.targets = data;
    },
  },
  actions: {
    async get_dashboard({ commit }, month) {
      const response = await axios.get("/sales_dashboard", {
        params: month ? { month } : {},
      });
      commit("SET_DASHBOARD", response.data);
      return response.data;
    },
    async get_targets({ commit }, month) {
      const response = await axios.get("/sales_targets", {
        params: month ? { month } : {},
      });
      commit("SET_TARGETS", response.data);
      return response.data;
    },
    async save_target(_, payload) {
      const response = await axios.post("/sales_targets", payload);
      return response.data;
    },
  },
};
